'use client'

import { useCallback } from 'react'
import { useRouter } from 'next/navigation'
import { sendAnalyticsEvent } from '@sylveraio/react-utils'
import { addBreadcrumb } from '@sentry/nextjs'
import { signOut } from '../signOut'

const signInUrl = '/sign-in'

export const useLogout = () => {
  const router = useRouter()

  return useCallback(async () => {
    addBreadcrumb({
      message: 'User Side Navigation Logout Attempt',
    })

    await signOut(
      () => {
        sendAnalyticsEvent({ eventName: 'app-navigation-logout' })
        router.push(signInUrl)
      },
      () => {
        addBreadcrumb({
          message: 'User Side Navigation Logout Failure',
        })
      },
    )
  }, [router])
}
